// extracted by mini-css-extract-plugin
export default {"beercard":"style_beercard__71a8h","cardimg":"style_cardimg__1jQpm","img":"style_img__lOSKr","card":"style_card__Gt7AH"};